// extracted by mini-css-extract-plugin
module.exports = {"sectionBreakParagraph":"styles_sectionBreakParagraph__UOZfz"};